import { useCallback, useContext, useEffect } from 'react'
import { HLSContext } from '../../context/hlsContext'
import { ViddyCoreContext } from '../../context/viddyCoreContext'
import { VideoSourceInfo } from '../../hooks/useHlsManager'

export const HLSReloader: React.FC = () => {
    const { hlsInstances } = useContext(HLSContext)
    const { indexes } = useContext(ViddyCoreContext)

    const videoIsLoaded = (v: VideoSourceInfo) => {
        return !!v.videoRef?.current?.src
    }
    const attachAndDetach = useCallback(() => {
        if (!hlsInstances.current) return
        const { mainIndex, subIndexes } = indexes
        const subIndex = subIndexes[mainIndex]

        for (let pIdx = 0; pIdx < hlsInstances.current.length; pIdx++) {
            for (
                let vIdx = 0;
                vIdx < hlsInstances.current[pIdx].length;
                vIdx++
            ) {
                // Preload instances
                const v = hlsInstances.current[pIdx][vIdx]

                if (subIndexes[pIdx] === vIdx && !videoIsLoaded(v)) {
                    v.videoManager.attachInstance(v)
                    continue
                }

                // Preload side-by-side videos in current playlist
                if (
                    pIdx === mainIndex &&
                    Math.abs(subIndex - vIdx) == 1 &&
                    !videoIsLoaded(v)
                ) {
                    v.videoManager.attachInstance(v)
                    continue
                }

                if (
                    pIdx === mainIndex &&
                    Math.abs(subIndex - vIdx) > 1 &&
                    videoIsLoaded(v)
                ) {
                    v.videoManager.detachInstance(v)
                    continue
                }

                if (
                    pIdx !== mainIndex &&
                    !subIndexes.includes(vIdx) &&
                    videoIsLoaded(v)
                ) {
                    v.videoManager.detachInstance(v)
                    continue
                }
            }
        }
    }, [indexes])

    useEffect(() => {
        const i = setTimeout(() => {
            attachAndDetach()
        }, 100)
        return () => clearTimeout(i)
    }, [])

    // Ensure effective preloading
    useEffect(() => {
        attachAndDetach()
    }, [indexes])
    return null
}
